import { Component, ElementRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Departments, Inventory, LocationType, ProcessorUsers, UserModel, usersDetails, WarehouseLocationsModels } from '../../../Models/ApplicationModels';
import { BreadcrumbService } from '../../../Services/breadcrumb.service';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-move-to-floor',
  templateUrl: './move-to-floor.component.html',
  styleUrls: ['./move-to-floor.component.css']
})
export class MoveToFloorComponent {
  hidebtn: boolean = false;
  arrForresult: any[] = [];
  users: Array<ProcessorUsers> = [];
  user: usersDetails = new usersDetails();
  inventory: Array<Inventory> = [];
  item: Inventory = new Inventory();
  currentUser: number = 0;
  location: Array<WarehouseLocationsModels> = [];
  Deptpriceconfigarray: Array<Inventory> = [];
  Deptpriceconfigarray1: Array<Inventory> = [];
  DeptpriceconfigarrayforDepartment: Array<Inventory> = [];
  DeptpriceconfigarrayforCategory: Array<Inventory> = [];
  DeptpriceconfigarrayforFilters: Array<Inventory> = [];
  DeptpriceconfigarrayforColor: Array<Inventory> = [];
  DeptpriceconfigarrayforLocation: Array<Inventory> = [];
  Deptpriceconfigarrayforcompany: Array<Inventory> = [];
  JournalArrayForItemEntry: Array<Inventory> = [];
  priceconfig: Inventory = new Inventory;
  departmentslist: Array<Departments> = [];
  filterName: string = 'Department'
  filterCategoriesIDs: number[] = []
  filterColorIDs: number[] = []
  filterLocationIDs: number[] = []
  conditionIDs: number[] = []
  filterDepartmentIDs: number[] = []
  headerCheckboxSelected: boolean = false;
  noData: boolean = false;
  showDept: boolean = true; showCtg: boolean = false; showColor: boolean = false;
  showLocation: boolean = false; showInventory: boolean = false; showInventorya: boolean = false; showTOLocation: boolean = false;
  selected: number = 4;
  arr: any[] = [];
  userdata: any;
  selectedDeptForFiletr: any[] = [];
  locationID: number = 3;
  arrayForsort: { key: string, value: boolean }[] = [
    { key: 'Department', value: false },
    { key: 'Category', value: false },
    { key: 'Week Color', value: false },
    { key: 'From Location', value: false },
    { key: 'TO Location', value: false },
    { key: 'Inventory', value: false },
  ];

  // Search query for the top search box
  searchQuery: string = '';

  @ViewChild('tagButton') tagButton?: ElementRef<HTMLElement>;
  constructor(private breadcrumbService: BreadcrumbService, private masterservice: MasterDataSeriveService, private toastr: ToastrService) { }

  ngOnInit() {
    this.breadcrumbService.updateActiveDeptTab('Home');
    this.breadcrumbService.updateActiveCategoryTab('Move To Floor');
    this.getUserDetailsByCompany();
    this.getLocationType();
    this.userData();
  }

  ngAfterViewInit() {
    // Add a click event listener to label elements
    const labelElements = document.querySelectorAll('.form-check-label');
    labelElements.forEach(label => {
      label.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevent dropdown from closing
      });
    });
  }

  showSuccess(location: string) {
    this.toastr.success(`Added to Floor`, 'Success')
  }

  getUserDetailsByCompany() {
    let userdata = this.masterservice.getUserDetailsFromStorage();

    this.user.userID = userdata.userId;
    this.getInventory(this.user.userID);
    let id = userdata.companyID;
    this.masterservice.getProcessorUsers(id).subscribe((res) => {
      if (res) {
        this.users = res as ProcessorUsers[];
      }
    });
  }

  getLocationType() {
    let user = this.masterservice.getUserDetailsFromStorage()
    let storeId = JSON.parse(localStorage.getItem('storeId')!);
    this.masterservice.getWarehouseLocations(user.companyID, storeId).subscribe((res) => {
      this.location = res as WarehouseLocationsModels[];
      let store = localStorage.getItem('tempStoreId')!;
      if (!store) {
        store = localStorage.getItem('storeId')!;
      }
      let defaultStore = parseInt(store);
      this.location = this.location.filter((item) => (item.storeId == defaultStore && item.eligibleForMovement == true));
    })
  }

  getInventory(userID: number) {
    while (this.JournalArrayForItemEntry.length > 0) {
      this.JournalArrayForItemEntry.pop();
    }
    while (this.arr.length > 0) {
      this.arr.pop();
    }
    let userdata = this.masterservice.getUserDetailsFromStorage();

    this.masterservice.getInventoryByUser(userID, userdata.companyID).subscribe((res) => {
      this.inventory = res as Inventory[];
      this.inventory.sort((a, b) => a.departmentDescr.localeCompare(b.departmentDescr));
      this.Deptpriceconfigarray = res as Inventory[];
      this.Deptpriceconfigarray1 = res as Inventory[];

      this.getseparatedataforFilters();

    });
  }

  getseparatedataforFilters() {
    this.DeptpriceconfigarrayforDepartment = this.Deptpriceconfigarray1
    this.DeptpriceconfigarrayforCategory = this.Deptpriceconfigarray1
    this.DeptpriceconfigarrayforFilters = this.Deptpriceconfigarray1
    this.DeptpriceconfigarrayforColor = this.Deptpriceconfigarray1
    this.DeptpriceconfigarrayforLocation = this.Deptpriceconfigarray1

    var filterArray = this.DeptpriceconfigarrayforDepartment.reduce((accumulator: any, current) => {
      if (!accumulator.some((item: any) => item.departmentId === current.departmentId)) {
        current.isSelected = false;
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    this.DeptpriceconfigarrayforFilters = filterArray;
    this.DeptpriceconfigarrayforDepartment = filterArray;

    var filterArray1 = this.DeptpriceconfigarrayforCategory.reduce((accumulator: any, current) => {
      if (!accumulator.some((item: any) => item.categoryId === current.categoryId)) {
        current.cIsSelected = false;
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    this.DeptpriceconfigarrayforCategory = filterArray1;

    var filterArray3 = this.DeptpriceconfigarrayforColor.reduce((accumulator: any, current) => {
      if (!accumulator.some((item: any) => item.productionCycleId === current.productionCycleId)) {
        current.pIsSelected = false;
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    this.DeptpriceconfigarrayforColor = filterArray3;

    var filterArray4 = this.DeptpriceconfigarrayforLocation.reduce((accumulator: any, current) => {
      if (!accumulator.some((item: any) => item.locationId === current.locationId)) {
        if (current.locationTypeDesc != null) {
          current.lIsSelected = false;
          accumulator.push(current);
        }
      }
      return accumulator;
    }, []);
    this.DeptpriceconfigarrayforLocation = filterArray4;
  }

  collectFilterParameters(search: any) {
    this.DeptpriceconfigarrayforFilters.forEach((elements: Inventory) => {
      if (this.filterName === 'Department' && elements.departmentId == search) {
        elements.isSelected = !elements.isSelected
        if (elements.isSelected) {
          this.selectedDeptForFiletr.push(search)

        }
        else {
          this.selectedDeptForFiletr = this.selectedDeptForFiletr.filter(item => item != search);

        }
      }
      else if (this.filterName === 'Category' && elements.categoryId == search) {
        elements.cIsSelected = !elements.cIsSelected
      }
      else if (this.filterName === 'Color' && elements.productionCycleId == search) {
        elements.pIsSelected = !elements.pIsSelected
      } else if (this.filterName === 'Location' && elements.locationId == search) {
        elements.lIsSelected = !elements.lIsSelected
      }
    });

    if (this.filterName === 'Department') {
      this.toggleFilterParameter(this.filterDepartmentIDs, search);
    } else if (this.filterName === 'Category') {
      this.toggleFilterParameter(this.filterCategoriesIDs, search);
    } else if (this.filterName === 'Color') {
      this.toggleFilterParameter(this.filterColorIDs, search);
    } else if (this.filterName == 'Location') {
      this.toggleFilterParameter(this.filterLocationIDs, search)
    }
  }

  toggleFilterParameter(filterArray: any[], search: any) {
    const index = filterArray.indexOf(search);
    if (index !== -1) {
      filterArray.splice(index, 1);
    } else {
      filterArray.push(search);
    }
  }

  getFilterData() {
    const filteredArray = this.Deptpriceconfigarray1.filter(item => {
      const deptFilter = this.filterDepartmentIDs.length === 0 || this.filterDepartmentIDs.includes(item.departmentId);
      const categoryFilter = this.filterCategoriesIDs.length === 0 || this.filterCategoriesIDs.includes(item.categoryId);
      const configFilter = this.filterColorIDs.length === 0 || this.filterColorIDs.includes(item.productionCycleId);
      const locFilter = this.filterLocationIDs.length === 0 || this.filterLocationIDs.includes(item.locationId);
      return deptFilter && categoryFilter && configFilter && locFilter
    });

    if (this.filterDepartmentIDs.length === 0 && this.filterCategoriesIDs.length === 0 && this.filterColorIDs.length === 0 && this.filterLocationIDs.length === 0) {
      this.Deptpriceconfigarray = filteredArray.length ? filteredArray : this.Deptpriceconfigarray1;
      this.noData = false;
    }
    else if (filteredArray.length == 0) {
      this.Deptpriceconfigarray = filteredArray
      this.noData = true;
    }
    else {
      this.Deptpriceconfigarray = filteredArray
    }
  }

  triggerTagButtonClick() {
    if (this.tagButton) {
      this.tagButton.nativeElement.click();
    }
  }

  selectedFilterCategory(dta: any) {
    this.filterName = dta
    if (dta == 'Department') {
      this.DeptpriceconfigarrayforFilters = this.DeptpriceconfigarrayforDepartment
    }
    else if (dta == 'Category') {
      this.DeptpriceconfigarrayforFilters = this.DeptpriceconfigarrayforCategory
      if (this.selectedDeptForFiletr.length) {


        this.DeptpriceconfigarrayforFilters = this.DeptpriceconfigarrayforFilters.filter(item => this.selectedDeptForFiletr.includes(item.departmentId))

      }
    }
    else if (dta == 'Color') {
      this.DeptpriceconfigarrayforFilters = this.DeptpriceconfigarrayforColor
    } else if (dta == 'Location') {
      this.DeptpriceconfigarrayforFilters = this.DeptpriceconfigarrayforLocation;
    }
  }

  clearFilter(dta: any) {
    if (dta == 'Department') {
      this.filterDepartmentIDs = []
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.isSelected = false
      })
    }
    else if (dta == 'Category') {
      this.filterCategoriesIDs = []
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.cIsSelected = false
      })
    }
    else if (dta == 'Color') {
      this.filterColorIDs = []
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.pIsSelected = false
      })
    } else if (dta == 'Location') {
      this.filterLocationIDs = [];
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.lIsSelected = false
      })
    }
    this.noData = false;
    this.getFilterData()
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;
    if (this.headerCheckboxSelected) {
      this.hidebtn = true;
      this.triggerTagButtonClick();
      this.Deptpriceconfigarray.map((res) => {
        res.checked = false;
        res.adjQty = res.qty;
      });
    }
    else {
      this.hidebtn = false;
      this.Deptpriceconfigarray.map((res) => {
        res.checked = true;
        res.adjQty = 0;
      });
    }
    this.checkChecked();
  }

  getIndex(item: any) {

  }
  changeLoc(id: number) {
    this.Deptpriceconfigarray.forEach((res) => {
      res.toLocationId = id;
    })
  }
  checkIndex(item: Inventory) {
    if (this.JournalArrayForItemEntry.length > 0) {
      let found = false;
      this.JournalArrayForItemEntry.forEach((res, index) => {
        if (res.inventSumId === item.inventSumId) {
          this.JournalArrayForItemEntry[index] = item;
          found = true;
        }
      });
      if (!found) {
        this.JournalArrayForItemEntry.push(item);
      }
    } else {
      this.JournalArrayForItemEntry.push(item);
    }

    this.addJournal();
  }

  handleCheckboxChange(indx: any, item: Inventory) {

    if (this.JournalArrayForItemEntry.length > 0) {
      let found = false;
      this.JournalArrayForItemEntry.forEach((res, index) => {
        if (res.inventSumId === item.inventSumId) {
          this.JournalArrayForItemEntry[index] = item;
          found = true;
        }
      });
      if (!found) {
        this.JournalArrayForItemEntry.push(item);
      }
    } else {
      this.JournalArrayForItemEntry.push(item);
    }

    if (this.arr.includes(indx)) {
      this.arr = this.arr.filter(item => item != indx)

    }
    else {
      this.arr.push(indx)

    }

    if (this.arr.length) {
      this.hidebtn = true;
    }
    else {
      this.hidebtn = false;
    }

    let indxToCompare = 0;
    this.Deptpriceconfigarray.forEach(ele => {
      indxToCompare += 1;
      if (indxToCompare == indx + 1) {
        if (ele.checked) {
          ele.checked = false;
          ele.adjQty = ele.qty;
        }
        else {
          ele.checked = true;
          ele.adjQty = 0;
        }
      }
    });
  }

  checkChecked() {
    if (this.JournalArrayForItemEntry.length == 0) {
      this.Deptpriceconfigarray.map((res) => {
        if (res.checked == false) {
          this.JournalArrayForItemEntry.push(res);
        }
      })
    } else {
      while (this.JournalArrayForItemEntry.length > 0) {
        this.JournalArrayForItemEntry.pop();
      }
    }
  }

  finalStatus(val: any, index: any) {
    if (val.key != 'Backspace') {
      this.arrForresult.push(index)
    }

    else {
      if (this.arrForresult.includes(index)) {
        const indx = this.arrForresult.indexOf(index)
        this.arrForresult.splice(indx, 1);
      }
    }

    if (this.arrForresult.includes(index)) {
      for (let i = 0; i < this.Deptpriceconfigarray.length; i++) {
        if (i == index) {
          this.Deptpriceconfigarray[i].checked = false;
        }
      }
    }
    else {
      for (let i = 0; i < this.Deptpriceconfigarray.length; i++) {
        if (i == index) {
          this.Deptpriceconfigarray[i].checked = true;
        }
      }
    }

    if (this.arrForresult.length) {
      this.hidebtn = true;
    }
    else {
      this.hidebtn = false;
    }
  }

  showCountBtn(inputval: any, indx: any, item: any) {
    if (this.JournalArrayForItemEntry.length > 0) {
      let found = false;
      this.JournalArrayForItemEntry.forEach((res, index) => {
        if (res.inventSumId === item.inventSumId) {
          this.JournalArrayForItemEntry[index] = item;
          found = true;
        }
      });
      if (!found) {
        this.JournalArrayForItemEntry.push(item);
      }
    } else {
      this.JournalArrayForItemEntry.push(item);
    }
    this.finalStatus(inputval, indx)
  }

  /*  async addJournal() {
      for (let i = 0; i < this.JournalArrayForItemEntry.length; i++) {
        await this.SaveJournal(this.JournalArrayForItemEntry[i]);
      }
      this.resetAll();
    }

    async SaveJournal(item: Inventory) {
      item.processorID = this.userdata.userId;
      item.storeId = parseInt(localStorage.getItem('storeId')!);

      item.journalTypeID = 1;
     await this.masterservice.addJournal(item).subscribe((res) => {
        this.showSuccess(item.locationTypeDesc);
     })
    }

    */

  resetAll() {


    this.getUserDetailsByCompany();
    this.hidebtn = !this.hidebtn;
    this.headerCheckboxSelected = false;
  }

  addJournal() {
    if (!this.JournalArrayForItemEntry?.length) return;

    let completedCount = 0;

    this.JournalArrayForItemEntry.forEach(item => {
      this.saveJournal(item, () => {
        completedCount++;
        // Once all items are saved, reset everything
        if (completedCount === this.JournalArrayForItemEntry.length) {
          this.resetAll();
        }
      });
    });
  }

  saveJournal(item: Inventory, onComplete: () => void) {
    const userId = this.userdata.userId;
    const storeId = parseInt(localStorage.getItem('storeId')!, 10);

    item.processorId = userId;
    item.storeId = storeId;
    item.journalTypeId = 1;
    item.fromLocationId = item.locationId;

    this.masterservice.addJournal([item]).subscribe({
      next: (res) => {
        this.showSuccess(item.locationTypeDesc);
        onComplete();
      },
      error: (err) => {
        console.error('Error while saving journal:', err);
        onComplete(); // still mark complete so resetAll eventually fires
      }
    });
  }

  userData() {
    this.userdata = this.masterservice.getUserDetailsFromStorage();
  }

  showhide(index: number) {

    if (index === 0) {
      this.showDept = !this.showDept;
    } else if (index === 1) {
      this.showCtg = !this.showCtg;
    } else if (index === 2) {
      this.showColor = !this.showColor;
    } else if (index === 3) {

      this.showLocation = !this.showLocation;
    } else if (index === 4) {
      this.showTOLocation = !this.showTOLocation;
    } else if (index === 5) {
      this.showInventory = !this.showInventory;
    }

    this.fetchData();
  }

  fetchData() {
    let user = this.masterservice.getUserDetailsFromStorage()
    this.masterservice.filterFloorJournal(this.showDept, !this.showCtg, user.userId, !this.showColor, !this.showLocation, user.companyID).subscribe((res) => {
      this.Deptpriceconfigarray = res as Inventory[];
      this.Deptpriceconfigarray.map((res) => {
        res.toLocationId = 3;
      })
    })
  }

  /**
   * Filters the displayed list using `searchQuery`.
   * Matches against departmentDescr, categoryName, barcode and locationTypeDesc.
   */
  onSearch() {
    const q = (this.searchQuery || '').trim().toLowerCase();
    if (!q) {
      // restore full list
      this.Deptpriceconfigarray = this.Deptpriceconfigarray1.slice();
      return;
    }

    this.Deptpriceconfigarray = this.Deptpriceconfigarray1.filter(item => {
      const dept = (item.departmentDescr || '').toString().toLowerCase();
      const cat = (item.categoryName || '').toString().toLowerCase();
      const barcode = (item.barcode || '').toString().toLowerCase();
      const loc = (item.locationTypeDesc || '').toString().toLowerCase();

      return (
        dept.includes(q) ||
        cat.includes(q) ||
        barcode.includes(q) ||
        loc.includes(q)
      );
    });
  }
}
